<template lang="pug">
.custom_dialog
  .dialog_container
    .dialog_close_btn(@click="closeClick")
      img(src="@/assets/img/icons/close.svg")
    .dialog_title.text-center
      h3 {{ productGroupSelect.name }}
    .dialog_content
      #accordion.mb-5.mt-3(v-html="productGroupSelect.info")
      .row.submit-btn.mt-3.justify-content-center
        .col-md-12.text-center
          h5.agree 您是否同意以上規範
            span
              input(type="checkbox", v-model="checkBox")
            span 同意
        .col-md-12.text-center
          .send_btn(@click="continueEnroll") 繼續報名
</template>

<script>
import { errorMessage } from "@/utils/message";

export default {
  name: "DialogStandard",
  props: {
    productGroupSelect: Object,
  },
  data() {
    return {
      checkBox: false,
    };
  },
  methods: {
    closeClick() {
      this.$emit("closeStandardDialogShow");
    },
    continueEnroll() {
      if (this.checkBox) {
        this.$emit("continueEnroll");
      } else {
        errorMessage(this, "警告", "請確認是否同意以上規範");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/dialog/dialog";
@import "@/assets/style/enroll/standard";

.custom_dialog {
  .dialog_container {
    overflow: hidden;
    height: 90%;
    width: 80%;
  }

  .dialog_close_btn {
    position: relative;
    right: 0;
    float: right;
  }

  .dialog_title {
    h3 {
      font-size: 20px;
    }
  }

  .dialog_content {
    height: 100%;
    overflow-y: auto;
    clear: both;
    padding-bottom: 30px;

    p {
      text-align: left;
    }
  }
}

@media (max-width: 767px) {
  .custom_dialog {
    .dialog_container {
      overflow: hidden;
      height: 95%;
      width: 100%;
    }
  }
}
</style>
